// Safely extracts a human-readable error message from an axios error response.
// FastAPI 422 validation errors return `detail` as an ARRAY of objects like
// [{type, loc, msg, input, ...}]. Passing that array (or a single object) to
// toast() / rendering it in React crashes the page with "React error #31".
// This helper always returns a string.
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (typeof e === 'string' ? e : (e?.msg || JSON.stringify(e))))
      .join('; ');
  }
  if (detail && typeof detail === 'object') {
    return detail.msg || JSON.stringify(detail);
  }
  if (typeof error?.message === 'string') return error.message;
  return fallback;
};
